import React from "react";
import { UserDetailsFormContextProvider } from "../UserDetailsFormContextProvider";
import UserDetailsFormBase from "../UserDetailsFormBase/UserDetailsFormBase";

const UserDetailsForm = (props: { userId: string }) => {
    const { userId } = props;

    return (
        <UserDetailsFormContextProvider userId={userId}>
            <UserDetailsFormBase />
        </UserDetailsFormContextProvider>
    );
};

export default UserDetailsForm;
